var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


Shopify.taxChange = function(direction) {
  
  let process = !!direction;

  function adjustPrices(initState) {
    if (initState == 'checked' || process) {
      cardPrices();
      prodPrices();
      geneticPricing();
      FinanceCalculator();
    }
  }
  

  function cardPrices() {
    const cardPrices = document.querySelectorAll('[vat-card]');
    cardPrices.forEach(cardPrice => {
      const vatTrue = cardPrice.querySelector('[vat-true]');
      const vatFalse = cardPrice.querySelector('[vat-false]');

      if (process) {
        vatTrue.classList.add('hidden');
        vatFalse.classList.remove('hidden');
      } else {
        vatTrue.classList.remove('hidden');
        vatFalse.classList.add('hidden');
      }
    });
  }

  function prodPrices() {
    const fromPrices = document.querySelectorAll('[vat-from]');
    const prodPrices = document.querySelectorAll('[vat-prod]');
    const finaceCalcPrices = document.querySelectorAll('[data-from-prices]');

    prodPrices.forEach(prodPrice => {
      const price = prodPrice.getAttribute('vat-price') ;
      const vatPrice = parseFloat(price) * 1.2;
      if (process) {
        prodPrice.innerHTML = `From ${Shopify.formatMoney(price, '£{{amount}}')} Excl. VAT`;
      } else {
        prodPrice.innerHTML = `From ${Shopify.formatMoney(vatPrice, '£{{amount}}')} Incl. VAT`;
      }
    });

    fromPrices.forEach(fromPrice => {
      const price = fromPrice.getAttribute('vat-price');
      const vatPrice = parseFloat(price) * 1.2;

      if (process) {
        fromPrice.innerHTML = `From £${price} Per Month Excl. VAT`;
      } else {
        fromPrice.innerHTML = `From £${vatPrice} Per Month Incl. VAT`;
      }
    });

    finaceCalcPrices.forEach(finaceCalcPrice => {
      const vatTrue = finaceCalcPrice.querySelector('[data-vat-true]');
      const vatFalse = finaceCalcPrice.querySelector('[data-vat-false]');
      if (process) {
        vatTrue.classList.add('hidden');
        vatFalse.classList.remove('hidden');
      } else {
        vatTrue.classList.remove('hidden');
        vatFalse.classList.add('hidden');
      }
    });
  }
  
  function updatePrices(selector, formatString) {
    const elements = document.querySelectorAll(selector);
    elements.forEach(element => {
      const price = parseFloat(element.getAttribute('vat-price'));
      const formattedPrice = process ? price : price * 1.2;
      const suffix = !process ? ' Incl. VAT' : ' Excl. VAT';
      if (selector === '[vat-cart-total]') {
        element.innerHTML = `Total: ${Shopify.formatMoney(formattedPrice, formatString)}`;
      } else { 
        element.innerHTML = `${Shopify.formatMoney(formattedPrice, formatString)}${suffix}`;
      }
    });
  }

  function FinanceCalculator() {
    const taxEvent = new Event('finance:tax');
    document.dispatchEvent(taxEvent);
  }

  function geneticPricing() {
    const selectors = [
      '[vat-cart-item]',
      '[vat-final-price]',
      '[vat-cart-total]',
      '[vat-mini-cart-item]',
    ];
    selectors.forEach(selector => {
      updatePrices(selector, '£{{amount}}');
    });
  }

  adjustPrices(localStorage.getItem('vat'));
};

 Shopify.priceLoader = function() {
    const miniCartItems = document.querySelectorAll('[vat-mini-cart-item]');
    const cardPriceItems = document.querySelectorAll('[vat-card]');
    miniCartItems.forEach(miniCartItem => {
      miniCartItem.classList.remove('animate-pulse', 'text-gray-200', 'bg-gray-200', 'rounded-md'); 
    });
    cardPriceItems.forEach(cardPriceItem => {
      cardPriceItem.classList.remove('opacity-0'); 
    });
  }


document.addEventListener('DOMContentLoaded', () => {
  Shopify.taxChange();
  Shopify.priceLoader();
});

document.addEventListener('variant:change', () => {
  setTimeout(() => {
    Shopify.taxChange(false);
  }
  , 1200);
});
